import RequestPrescreenerBillingPaymentController from 'client-portal/controllers/-request/prescreener-billing-payment';

export default class WidgetPrescreenerBillingPayment extends RequestPrescreenerBillingPaymentController {}
